// source: model_config.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.ai.config.LlmApplicationUseCase', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams.displayName = 'proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings.displayName = 'proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting.displayName = 'proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams.displayName = 'proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.displayName = 'proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment.displayName = 'proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig.displayName = 'proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams.toObject = function(includeInstance, msg) {
  var f, obj = {
maxOutputTokens: jspb.Message.getFieldWithDefault(msg, 1, 0),
temperature: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
topP: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams}
 */
proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams;
  return proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams}
 */
proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxOutputTokens(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setTemperature(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setTopP(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMaxOutputTokens();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTemperature();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getTopP();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
};


/**
 * optional int32 max_output_tokens = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams.prototype.getMaxOutputTokens = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams} returns this
 */
proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams.prototype.setMaxOutputTokens = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional float temperature = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams.prototype.getTemperature = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams} returns this
 */
proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams.prototype.setTemperature = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float top_p = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams.prototype.getTopP = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams} returns this
 */
proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams.prototype.setTopP = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings.toObject = function(includeInstance, msg) {
  var f, obj = {
settingsList: jspb.Message.toObjectList(msg.getSettingsList(),
    proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings}
 */
proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings;
  return proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings}
 */
proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting.deserializeBinaryFromReader);
      msg.addSettings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSettingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SafetySetting settings = 1;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting>}
 */
proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings.prototype.getSettingsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting, 1));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting>} value
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings} returns this
*/
proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings.prototype.setSettingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting}
 */
proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings.prototype.addSettings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings} returns this
 */
proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings.prototype.clearSettingsList = function() {
  return this.setSettingsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting.toObject = function(includeInstance, msg) {
  var f, obj = {
category: jspb.Message.getFieldWithDefault(msg, 1, ""),
threshold: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting}
 */
proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting;
  return proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting}
 */
proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setThreshold(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getThreshold();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string category = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting} returns this
 */
proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string threshold = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting.prototype.getThreshold = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting} returns this
 */
proto.org.codetricks.construction.code.assistant.ai.config.SafetySetting.prototype.setThreshold = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams.toObject = function(includeInstance, msg) {
  var f, obj = {
enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
thinkingLevel: jspb.Message.getFieldWithDefault(msg, 2, ""),
thinkingBudgetOverride: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams}
 */
proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams;
  return proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams}
 */
proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setThinkingLevel(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setThinkingBudgetOverride(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getThinkingLevel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getThinkingBudgetOverride();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams} returns this
 */
proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string thinking_level = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams.prototype.getThinkingLevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams} returns this
 */
proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams.prototype.setThinkingLevel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 thinking_budget_override = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams.prototype.getThinkingBudgetOverride = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams} returns this
 */
proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams.prototype.setThinkingBudgetOverride = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.toObject = function(includeInstance, msg) {
  var f, obj = {
profileId: jspb.Message.getFieldWithDefault(msg, 1, ""),
displayName: jspb.Message.getFieldWithDefault(msg, 2, ""),
modelName: jspb.Message.getFieldWithDefault(msg, 3, ""),
generationParams: (f = msg.getGenerationParams()) && proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams.toObject(includeInstance, f),
thinkingParams: (f = msg.getThinkingParams()) && proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams.toObject(includeInstance, f),
description: jspb.Message.getFieldWithDefault(msg, 6, ""),
safetySettings: (f = msg.getSafetySettings()) && proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile}
 */
proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile;
  return proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile}
 */
proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProfileId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelName(value);
      break;
    case 4:
      var value = new proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams.deserializeBinaryFromReader);
      msg.setGenerationParams(value);
      break;
    case 5:
      var value = new proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams.deserializeBinaryFromReader);
      msg.setThinkingParams(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 7:
      var value = new proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings.deserializeBinaryFromReader);
      msg.setSafetySettings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProfileId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getModelName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getGenerationParams();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams.serializeBinaryToWriter
    );
  }
  f = message.getThinkingParams();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams.serializeBinaryToWriter
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSafetySettings();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings.serializeBinaryToWriter
    );
  }
};


/**
 * optional string profile_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.prototype.getProfileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile} returns this
 */
proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.prototype.setProfileId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile} returns this
 */
proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string model_name = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.prototype.getModelName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile} returns this
 */
proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.prototype.setModelName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional GenerationParams generation_params = 4;
 * @return {?proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams}
 */
proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.prototype.getGenerationParams = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams, 4));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.ai.config.GenerationParams|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile} returns this
*/
proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.prototype.setGenerationParams = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile} returns this
 */
proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.prototype.clearGenerationParams = function() {
  return this.setGenerationParams(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.prototype.hasGenerationParams = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional ThinkingParams thinking_params = 5;
 * @return {?proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams}
 */
proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.prototype.getThinkingParams = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams, 5));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.ai.config.ThinkingParams|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile} returns this
*/
proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.prototype.setThinkingParams = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile} returns this
 */
proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.prototype.clearThinkingParams = function() {
  return this.setThinkingParams(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.prototype.hasThinkingParams = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string description = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile} returns this
 */
proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional SafetySettings safety_settings = 7;
 * @return {?proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings}
 */
proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.prototype.getSafetySettings = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings, 7));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.ai.config.SafetySettings|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile} returns this
*/
proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.prototype.setSafetySettings = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile} returns this
 */
proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.prototype.clearSafetySettings = function() {
  return this.setSafetySettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.ai.config.ModelProfile.prototype.hasSafetySettings = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment.toObject = function(includeInstance, msg) {
  var f, obj = {
useCase: jspb.Message.getFieldWithDefault(msg, 1, 0),
profileId: jspb.Message.getFieldWithDefault(msg, 2, ""),
roleProfilesMap: (f = msg.getRoleProfilesMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment}
 */
proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment;
  return proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment}
 */
proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.ai.config.LlmApplicationUseCase} */ (reader.readEnum());
      msg.setUseCase(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProfileId(value);
      break;
    case 3:
      var value = msg.getRoleProfilesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUseCase();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getProfileId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRoleProfilesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional LlmApplicationUseCase use_case = 1;
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.LlmApplicationUseCase}
 */
proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment.prototype.getUseCase = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.ai.config.LlmApplicationUseCase} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.ai.config.LlmApplicationUseCase} value
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment} returns this
 */
proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment.prototype.setUseCase = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string profile_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment.prototype.getProfileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment} returns this
 */
proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment.prototype.setProfileId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * map<string, string> role_profiles = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment.prototype.getRoleProfilesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment} returns this
 */
proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment.prototype.clearRoleProfilesMap = function() {
  this.getRoleProfilesMap().clear();
  return this;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
useCaseOverridesList: jspb.Message.toObjectList(msg.getUseCaseOverridesList(),
    proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig}
 */
proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig;
  return proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig}
 */
proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment.deserializeBinaryFromReader);
      msg.addUseCaseOverrides(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUseCaseOverridesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UseCaseModelAssignment use_case_overrides = 1;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment>}
 */
proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig.prototype.getUseCaseOverridesList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment, 1));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment>} value
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig} returns this
*/
proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig.prototype.setUseCaseOverridesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment}
 */
proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig.prototype.addUseCaseOverrides = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.codetricks.construction.code.assistant.ai.config.UseCaseModelAssignment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig} returns this
 */
proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig.prototype.clearUseCaseOverridesList = function() {
  return this.setUseCaseOverridesList([]);
};


/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.ai.config.LlmApplicationUseCase = {
  LLM_USE_CASE_UNSPECIFIED: 0,
  PLAN_INGESTION: 1,
  CODE_APPLICABILITY: 2,
  COMPLIANCE_ANALYSIS: 3,
  CHAT_AGENT: 4,
  CHAT_DECORATOR: 5,
  CHAT_SESSION_SUMMARY: 6,
  VOICE_TRANSCRIPT_CLEANUP: 7,
  IMAGE_OBJECT_SEARCH: 8,
  IMAGE_SEARCH_ENSEMBLE: 9,
  IMAGE_SEARCH_DIRECT: 10,
  IMAGE_SEARCH_AGENT: 11,
  CROSS_REFERENCE_GRAPH: 12,
  BUILDING_ELEMENT_REGISTRY: 13,
  CROSS_EXAMINATION: 14,
  IMAGE_SEARCH_DISCOVERY: 15,
  REGION_HIERARCHY_DECOMPOSE: 16,
  REGION_HIERARCHY_TRANSCRIBE: 17,
  ICC_CHAPTER_SUMMARY: 50
};

goog.object.extend(exports, proto.org.codetricks.construction.code.assistant.ai.config);
